import { Color } from "@app/types/Color";

export const SkodaColors: Color = {
    success: "#38bd9f",
    error: "#ff001e",
    secondary: "#ffa200",
};
